import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { Errors } from "@/@types";

interface Props {
  error: Errors;
  retriable: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    error: null,
    retriable: { type: Boolean }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  error: Errors;
  retriable: boolean;
};


const error = computed(() => props.error);

function tryAgain() {
  window.location.reload();
}

const __returned__ = { props, error, tryAgain, computed, get Errors() { return Errors } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})